@if (data?.length > 0) {
  <app-generic-list class="frontend smart" [frontend]="true"
                    [data]="data"
                    [columns]="columns" [columnsMobile]="columnsMobile"
                    [scrollable]="false" [selectionMode]="undefined"

                    [mobileRowTemplate]="mobileRowTemplate"
                    [hideMobileRowButtonsColumn]="true"

                    (onRowSelect)="onRowSelect($event)" [rowSelect]="false"/>
} @else {
  {{ 'NO_REGISTRATIONS' | translate}}
}

<ng-template #mobileRowTemplate let-item="data" pTemplate="item">
  <td>
    <div class="flex align-items-center gap-2">
      <div>
        <ng-container [ngTemplateOutlet]="dateTemplate" [ngTemplateOutletContext]="{data: item}"/>
      </div>
      <div class="flex-1">
        <ng-container [ngTemplateOutlet]="eventInfoTemplate" [ngTemplateOutletContext]="{data: item}"/>
        <div class="pt-1">
          <ng-container [ngTemplateOutlet]="eventAddressTemplate" [ngTemplateOutletContext]="{data: item}"/>
        </div>
      </div>
      <div>
        <ng-container [ngTemplateOutlet]="eventButtonsTemplate" [ngTemplateOutletContext]="{data: item}"/>
      </div>
    </div>
  </td>
</ng-template>

<ng-template #dateTemplate let-item="data" pTemplate="item">
  <app-date-time-presenter [date]="item.date" [small]="true"/>
</ng-template>

<ng-template #eventInfoTemplate let-item="data" pTemplate="item">
  @if (item.match?.roundName) {
    <div class="text-gray-400">
      @if (view.isMobile && item.type) {
        {{item.type}}:&nbsp;
      }
      {{item.match.roundName}}
    </div>
  } @else if (item.type) {
    <div class="text-gray-400">
      {{item.type}}
    </div>
  }
  <div>
    {{item.name}}
    @if (item.match?.statusCd === 'FINISH' && (item.match?.setsHome > 0 || item.match?.setsAway > 0)) {
      &nbsp;({{item.match.setsHome}}:{{item.match.setsAway}})
    }
  </div>
</ng-template>

<ng-template #eventAddressTemplate let-item="data" pTemplate="item">
  @if (item.street || item.postalCode || item.city || item.playingVenue) {
    <div>
      <div [class.text-gray-400]="view.isMobile">
        {{item.street | addressPipe: item.postalCode: item.city}}
      </div>
      <div class="text-gray-400">
        {{item.playingVenue}}
      </div>
    </div>
  }
</ng-template>

<ng-template #matchInfoTemplate let-item="data" pTemplate="item">
  <div>
    @if (item.event) {
      <div [class.text-gray-400]="view.isMobile" [class.pb-0_5]="view.isMobile">
        {{item.event?.eventTypeCd | domainValuePipe: 'event-type'}}
      </div>
      <div class="text-gray-400" [class.pt-0_5]="view.isMobile">
        {{item.event?.eventKindCd | domainValuePipe: 'event-kind'}}
      </div>
    } @else if (item.match) {
      @if (item.match.gameNr) {
        <span>#{{item.match.gameNr}}</span>
      }
    }
  </div>
</ng-template>

<ng-template #eventButtonsTemplate let-item="data" pTemplate="item">
  <div class="flex align-items-center md:gap-2">
    @if (item.event) {
      <p-button icon="pi pi-calendar-minus"
                styleClass="p-button-rounded p-button-text text-accent no-padding"
                [disabled]="isDeregistering"
                [pTooltip]="'DEREGISTER' | translate" tooltipPosition="left"
                (click)="deregisterFromEvent(item.event)"/>

      <p-button icon="pi pi-external-link"
                styleClass="p-button-rounded p-button-text text-white no-padding"
                [pTooltip]="'TOURNAMENT_INFO_SHOW' | translate" tooltipPosition="left"
                (click)="openEventInfos(item.event)"/>
    }
    @if (item.match) {
      <p-button icon="pi pi-external-link"
                styleClass="p-button-rounded p-button-text text-white no-padding"
                [pTooltip]="'FRONTEND_LINK_MATCHPLAN' | translate" tooltipPosition="left"
                (click)="openLeagueMatchplan(item.match)"/>
    }
  </div>
</ng-template>

